module.exports = __webpack_public_path__ + "img/acne_ypgnbg_c_scale,w_952.9d481477.jpg";